import { render } from "./Team.vue?vue&type=template&id=b5b966a8"
import script from "./Team.vue?vue&type=script&lang=js"
export * from "./Team.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./Team.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__